module.exports = __webpack_public_path__ + "images/917cd98a3823890ce0c4502b8eb0f330.jpg";